import { useState } from "react";
import { AlertTriangle, TrendingDown, ArrowRight, Users, ChevronRight } from "lucide-react";
import { formatNum, formatPct } from "../lib/constants";
import PacientesAfectadosDialog from "./PacientesAfectadosDialog";

export default function FugaCard({ fuga, index }) {
  const [open, setOpen] = useState(false);
  const critica = fuga.critica || fuga.pct_perdida >= 50;

  return (
    <>
      <div
        data-testid={`fuga-card-${index}`}
        className={`relative rounded-2xl border p-5 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg ${
          critica
            ? "border-rose-200 bg-gradient-to-br from-rose-50 to-white hover:shadow-rose-200/60"
            : "border-amber-200 bg-gradient-to-br from-amber-50 to-white hover:shadow-amber-200/60"
        }`}
      >
        {critica && (
          <div className="absolute top-3 right-3 inline-flex items-center gap-1 rounded-full bg-rose-500 px-2 py-0.5 text-[10px] font-bold text-white">
            <AlertTriangle className="w-3 h-3" /> CRÍTICA
          </div>
        )}
        <div className="flex items-center gap-2 text-xs font-medium text-slate-600 mb-2">
          <span className="px-2 py-0.5 rounded-lg bg-white border border-slate-200">{fuga.desde}</span>
          <ArrowRight className="w-3.5 h-3.5 text-slate-400" />
          <span className="px-2 py-0.5 rounded-lg bg-white border border-slate-200">{fuga.hacia}</span>
        </div>
        <div className="flex items-baseline gap-2">
          <span className={`text-3xl font-bold ${critica ? "text-rose-600" : "text-amber-600"}`}>
            {formatPct(fuga.pct_perdida)}
          </span>
          <span className="text-sm text-slate-500 flex items-center gap-1">
            <TrendingDown className="w-3.5 h-3.5" /> pérdida
          </span>
        </div>
        <div className="mt-2 text-sm text-slate-700 font-medium">{formatNum(fuga.perdidos)} pacientes</div>
        <p className="mt-3 text-xs text-slate-600 leading-relaxed">{fuga.motivo}</p>

        <div className="mt-4 flex items-center justify-between gap-3">
          {fuga.origen && (
            <div className="inline-flex items-center text-[10px] font-semibold text-slate-500 uppercase tracking-wide">
              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${fuga.origen === "REAL" ? "bg-emerald-500" : "bg-slate-400"}`} />
              {fuga.origen === "REAL" ? "Dato real" : "Mock"}
            </div>
          )}
          <button
            data-testid={`drilldown-fuga-${index}`}
            onClick={() => setOpen(true)}
            className={`inline-flex items-center gap-1 text-xs font-semibold rounded-lg px-2.5 py-1.5 border transition hover:-translate-y-0.5 ${
              critica
                ? "bg-white border-rose-200 text-rose-700 hover:bg-rose-50 hover:border-rose-300"
                : "bg-white border-amber-200 text-amber-700 hover:bg-amber-50 hover:border-amber-300"
            }`}
          >
            <Users className="w-3.5 h-3.5" />
            Ver pacientes afectados
            <ChevronRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
      <PacientesAfectadosDialog fuga={fuga} open={open} onOpenChange={setOpen} />
    </>
  );
}
